import { http } from '@utils/index';

export interface Props {
	id: number;
}

const getSingleCourseProgress = (props: Props) => {
	return http.get<SaUserProgressRes[]>(
		`/sa/users/${props.id}/course-progress`
	);
};
export default getSingleCourseProgress;
